/**
=========================================================
* BASE: Learning Repository - v1.0.0
=========================================================

* Copyright 2022 Sean Dooley (https://www.dooley-dev.com)

Coded by www.dooley-dev.com

 =========================================================

* The above copyright notice shall be included in substantial portions of the Software.
*/
// React
import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import { commentCollectionsConfig } from './CommentCollectionsConfig';
// BASE Components
import BASESvgIcon from '../../../@BASE/core/BASESvgIcon';
// Material UI Components
import Avatar from '@mui/material/Avatar';
import CardHeader from '@mui/material/CardHeader';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
// Custom Components
import moment from 'moment';

function CommentCardHeader(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { pathname } = location;
  const pathArray = pathname.split('/');
  const resource = pathArray[1];
  const { comment, destination, isIMI = false, collection = 'comments' } = props;
  const [status, setStatus] = useState(() => comment.status ?? 'pending');
  useEffect(() => {
    setStatus(comment.status ?? 'pending');
  }, [comment]);

  const handleStatusChip = (status) => {
    switch (status) {
      case 'approved':
        return (
          <Chip
            className="capitalize font-semibold text-10"
            label="Approved"
            color="success"
            size="small"
            icon={<BASESvgIcon size={16}>heroicons-solid:check</BASESvgIcon>}
          />
        );
      case 'approvedWithComments':
        return (
          <Chip
            className="capitalize font-semibold text-10"
            label="Approved"
            color="success"
            size="small"
            icon={<BASESvgIcon size={16}>heroicons-solid:chat-alt</BASESvgIcon>}
          />
        );
      case 'disapproved':
        return (
          <Chip
            className="capitalize font-semibold text-10"
            label="Disapproved"
            color="error"
            size="small"
            icon={
              <BASESvgIcon size={16}>
                heroicons-outline:exclamation-circle
              </BASESvgIcon>
            }
          />
        );
      default:
        return (
          <Chip
            className="capitalize font-semibold text-10"
            label="Pending"
            variant="outlined"
            size="small"
            icon={
              <BASESvgIcon size={16}>
                heroicons-outline:minus-circle
              </BASESvgIcon>
            }
          />
        );
    }
  };

  const navigateToPage = () => {
    const base = commentCollectionsConfig[collection]?.redirect;
    navigate(`/${base}/${destination}`);
  };

  const addNavigationButton = () => {
    if (resource == 'pages') return;

    return (
      <Tooltip title="View Page">
        <IconButton className="mr-8" onClick={() => navigateToPage()}>
          <BASESvgIcon>heroicons-outline:external-link</BASESvgIcon>
        </IconButton>
      </Tooltip>
    );
  };

  return (
    <CardHeader
      avatar={
        <Avatar
          sx={{
            backgroundColor: comment.creator.settings.color,
            color:
              comment.creator.settings.color != '#013BB1' &&
              comment.creator.settings.color != '#481FA7'
                ? 'common.black'
                : 'common.white'
          }}
          className="text-16 font-bold"
        >
          {comment.creator.first_name[0]}
          {comment.creator.last_name[0]}
        </Avatar>
      }
      title={
        <Typography className="text-14 font-bold mr-16">
          {comment.creator.first_name} {comment.creator.last_name}
        </Typography>
      }
      subheader={
        <Typography color="text.secondary" className="text-12">
          {comment.updated_date
            ? moment
                .utc(comment.updated_date)
                .local()
                .format('MMM DD, YYYY, h:mm A z')
            : 'No date available'}
        </Typography>
      }
      action={
        <>
          {addNavigationButton()}
          {handleStatusChip(status)}
        </>
      }
    />
  );
}

export default CommentCardHeader;
